<template>
  <div class="rateEchart">
    <div class="echarts-title">客户评分：80（No.3）</div>
    <div class="echarts-rate" ref="RateEchart"></div>
  </div>
</template>

<script>
import * as charts from 'echarts'
export default {
  name: "RateEchart",
  data(){
    return {
      option:{
        tooltip: {
          trigger: 'item'
        },
        radar: {
          // shape: 'circle',
          indicator: [
            { name: '订单', max: 10 },
            { name: '口碑', max: 10 },
            { name: '结算', max: 10 },
            { name: '风险', max: 10 },
            { name: '客情', max: 10 }
          ]
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                value: [8, 3, 5, 5, 7],
                name: '用户评分'
              }
            ]
          }
        ]
      }
    }
  },
  mounted() {
    const echarts = charts.init(this.$refs['RateEchart'])
    echarts.setOption(this.option)
  }
}
</script>

<style scoped>
  .rateEchart{
    width: 25%;
    height: 364px;
    box-shadow:2px 0 12px 0 rgb(0 0 0 / 9%);
    margin-left: 3px;
    overflow: hidden;
  }
  .echarts-title{
    margin: 20px;
    font-size: 20px;
  }
  .echarts-rate{
    width: 80%;
    height: 300px;
    margin: 0 auto;
  }
</style>